module.exports = __webpack_public_path__ + "img/room04.64d50e14.jpg";